import Heading from "@components/layout/Heading";
import EventTransactionPaginatedTable from "@components/table/EventTransactionPaginatedTable";
import { useBalanceAdjustmentContext } from "@context/BalanceAdjustmentContext";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import EndButtonModal from "@components/shared/EndButton";

const CreateBalanceAdjustmentCompleted: FunctionComponent = () => {
  const { t } = useTranslation();
  const { workflowInstance } = useBalanceAdjustmentContext();

  return (
    <>
      <div className="flex flex-col gap-2 p-6 pb-0 grow">
        <Heading light>
          {t("balance_adjustment.create.workflow_complete")}
        </Heading>
        <EventTransactionPaginatedTable
          references={[workflowInstance?.id]}
          stickyHeader={true}
        />
      </div>
      <footer className="flex gap-4 p-6 border-t border-gray-200">
        <EndButtonModal />
      </footer>
    </>
  );
};

export default CreateBalanceAdjustmentCompleted;
